import { jsxs as i, jsx as d } from "react/jsx-runtime";
import { useState as g, createElement as u } from "react";
import { withManagedProps as S } from "@made-people/managed-props";
import { z as p } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { sizeGuideTableBlueprint as z } from "./index-blueprint.es.js";
import { tableSchema as s, Table as b } from "@made-people/blueprint-table";
import { headingSchema as G, Heading as T } from "@made-people/blueprint-heading";
import { Radio as m } from "@made-people/blueprint-form";
import "@made-people/blueprint";
const x = p.object({
  variants: p.custom().optional(),
  heading: G.optional(),
  metricCharts: s.array().optional(),
  imperialCharts: s.array().optional()
}), E = S(
  "SizeGuideTable",
  y(
    {
      schema: x,
      defaultProps: {}
    },
    ({ variants: f, metricCharts: e, imperialCharts: o, heading: c }) => {
      const n = z.styles(f), [t, r] = g(
        "metric"
      ), v = e && o && (e == null ? void 0 : e.length) > 0 && (o == null ? void 0 : o.length) > 0;
      return /* @__PURE__ */ i("div", { className: n.base, children: [
        /* @__PURE__ */ i("div", { className: n.header, children: [
          c && /* @__PURE__ */ d(T, { ...c, className: n.heading }),
          v && /* @__PURE__ */ i(
            m.RadioGroup,
            {
              value: t,
              onValueChange: (a) => {
                r(a);
              },
              children: [
                /* @__PURE__ */ d(m.RadioButton, { label: "cm", value: "metric" }),
                /* @__PURE__ */ d(m.RadioButton, { label: "inches", value: "imperial" })
              ]
            }
          )
        ] }),
        t === "metric" && (e == null ? void 0 : e.map((a, l) => /* @__PURE__ */ u(b, { ...a, key: l }))),
        t === "imperial" && (o == null ? void 0 : o.map((a, l) => /* @__PURE__ */ u(b, { ...a, key: l })))
      ] });
    }
  )
);
export {
  E as SizeGuideTable,
  x as sizeGuideTableSchema
};
//# sourceMappingURL=index.es.js.map
